export type Experience = {
  title: string;
  company: string;
  logo: string;
  location: string;
  timeframe: string;
  bullets: string[];
};

export const experiences: Experience[] = [
  {
    title: "Full Stack Engineer",
    company: "WonderSouq",
    logo: "/logos/wondersouq.jpg",
    location: "Istanbul, Turkey",
    timeframe: "02/2025 - Present",
    bullets: [
      "Leading the transition of software ownership from external contractors.",
      "Implementing new features and optimizing performance for a custom-built e-commerce platform using Reaction Commerce.",
      "Developing full-stack solutions using Node.js, Next.js, React, Redux, GraphQL, and MongoDB.",
      "Managing and deploying applications on AWS, ensuring scalability, security, and performance optimization.",
      "Collaborating with cross-functional teams to align development efforts with business goals.",
    ],
  },
  {
    title: "Full Stack Engineer",
    company: "REEF Technology",
    logo: "/logos/reef.jpg",
    location: "Istanbul, Turkey",
    timeframe: "06/2024 - 10/2024",
    bullets: [
      "Implemented over 20 backend endpoints using Node.js, TypeScript, TypeORM and Nest.js.",
      "Implemented GraphQL queries and mutations in Go.",
      "Resolved 15+ frontend and backend bugs based on user feedback.",
      "Ensured seamless deployments using GitHub and AWS achieving 100% uptime.",
      "Mentored Intern and Junior developers.",
    ],
  },
  {
    title: "Software Engineer",
    company: "Freelancing",
    logo: "/logos/S&ALogo.jpg",
    location: "Remote",
    timeframe: "01/2023 - Present",
    bullets: [
      "Developed complex web applications using Node.js, React, and Next.js.",
      "Designed REST APIs and GraphQL endpoints.",
      "Deployed applications using AWS and Google Firebase.",
      "Collaborated with 2 clients to understand and solve business needs.",
    ],
  },
  {
    title: "Software Engineer",
    company: "Skrey",
    logo: "/logos/skrey.jpg",
    location: "Porto, Portugal",
    timeframe: "11/2022 - 03/2024",
    bullets: [
      "Managed Kubernetes clusters for PCDiga.com on AWS and IBM Cloud.",
      "Released endpoints using Temporal for data migration from Magento or SAP to Saleor.",
      "Expanded Saleor’s functionality by implementing micro-backends with Typescript, Node.js, GraphQL, Redis, PostgreSQL/MongoDB.",
      "Created Docker templates and CI/CD pipelines.",
      "Wrote unit tests with 100% code coverage using Jest.",
    ],
  },

  {
    title: "Software Engineer",
    company: "Fited",
    logo: "/logos/fited.jpg",
    location: "Izmir, Turkey",
    timeframe: "06/2022 - 11/2022",
    bullets: [
      "Led design and implementation of microservice infrastructure in AWS.",
      "Migrated scoliosis system from Flask to Node.js, Nest.js, Prisma, and AWS AppSync.",
      "Optimized data model architecture and geometry processing logic.",
    ],
  },
  {
    title: "Full Stack Engineer",
    company: "Norhart",
    logo: "/logos/norhart.jpg",
    location: "Remote (Minnesota, USA)",
    timeframe: "10/2021 - 04/2022",
    bullets: [
      "Built frontend microservices with React and TypeScript.",
      "Created backend microservices using Node.js, GraphQL, and MySQL on AWS.",
      "Developed AWS Lambda functions for event tracking.",
      "Introduced coding standards improving code quality and team productivity.",
    ],
  }
];